export default function Logout() {
    return <div className='w-100 h-100'></div>;
}
